<template>
  <div style="display: flex; flex-wrap: wrap;">
    <div v-for="(props, i) of data" :key="`${i}`" class="CardIndicator">
      <router-link
        :to="{
          name: 'AnalyticsChart',
          params: { ...props.subGrafica, goBack }
        }"
      >
        <div class="CardHeaderIndicator">
          <div
            v-if="props.subGrafica"
            style="height: 30px;
                padding-right: 10px;
                padding-left: 10px;"
          />
        </div>
        <div
          style="flex-direction: column; flex-grow: 1; justify-content: space-evenly; margin-bottom: 10px"
        >
          <div
            style="text-align: center; font-style: 31px;"
            class="TextSubTitle FontsWhite"
          >
            {{ TextOrNumber(props.titulo, false, ".00") }}
          </div>
          <div
            style="text-align: center; font-style: 16px;"
            class="TextSubTitle FontsWhite"
          >
            {{ TextOrNumber(props.subtitulo, false, ".00") }}
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "NumericalIndicator",
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    goBack() {
      return this.$route?.params;
    }
  },

  methods: {
    TextOrNumber(str, ...rest) {
      return isNaN(str) ? str : this.$formatter(str, ...rest);
    }
  }
};
</script>

<style lang="scss" scoped>
.CardIndicator {
  background-color: #fb8e2c;
  border-radius: 16px;
  padding: 8px;
  height: 153px;
  min-width: 150px;
  margin-right: 10px;
  margin-top: 16px;
  margin-bottom: 8px;
  max-width: 150px;
  a:hover {
    text-decoration: none;
  }
}
.CardHeaderIndicator {
  flex-direction: row-reverse;
}
.TextSubTitle {
  font-weight: bold;
  font-size: 22px;
  color: #000;
}
.FontsWhite {
  color: #fff;
}
</style>
